import React, { useEffect, useState } from "react";
import Topbar from "../layouts/Topbar";
import PageHeader from "../components/PageHeader";
import SubHeader from "../components/SubHeader";
import CommonTable from "../components/Common_table";
import { useGlobalContext } from "../../context/Context";
import ViewConsultationPopup from "../../Admin/components/viewConsultationPopup";
import instance from "../../Utils/api";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Vieworder from "../components/View_order";
import ViewConsultationInfo from "../components/viewConsultationInfo";
import CancelConsultation from "../components/CancelConsultation";
import DownloadExportData from "../../Utils/excel";
import { toast } from "react-toastify";
import { CircularProgress } from "@mui/material";

const Consultation = () => {
  const url = window.location.pathname;

  const tabsData = [
    {
      label: "All",
      name: "",
      options: [],
    },
    {
      label: "In Person",
      name: "In Person",
      options: ["catalogue", "customer uploads"],
    },
    {
      label: "Online",
      name: "Online",
      options: ["catalogue", "customer uploads"],
    },
  ];
  const sortOptions = ["Assigned Person", "Unassigned Person"];
  const statusOptions = [
    "None", 'In Payment', 'Booked', 'Completed', 'Cancelled', 'Hold'
  ];
  const paymentOptions = ["None", "Paid", "Pending", "No Payment"];
  const SortOptions = ["None", "consultation_date", "createdAt"];
  const title = {
    name: "Consultations",
    subheading: "Follow up with your consultations",
    search: "Search consultations",
    button: "",
  };

  const columns = [
    { label: "S.No", field: "sno", },
    { label: "Order Id", field: "order_id", },
    { label: "Consultation ID", field: "ConsultationID", },
    { label: "Customer", field: "Customer", },
    { label: "Date", field: "Bookingdate", },
    { label: "Consultation Type", field: "consultationtype", },
    { label: "Assigned", field: "Assignedperson", },
    { label: "Consultation Status", field: "suborderstatus", },
    { label: "payment", field: "paymentstatus", },
    ...(url === '/admin/Reports/Consultation'
      ? []
      : [{ label: "Actions", field: "action", }])
  ];
  const { categoryId } = useParams();
  const { openDialog, setOpenDialog } = useGlobalContext();
  const { openviewDialog, setopenviewDialog } = useGlobalContext();
  const { openConsultationDialog, setOpenConsultationDialog } = useGlobalContext();
  const [edit, setEdit] = useState(false);
  const [consultationData, setConsultationData] = useState();
  const [selectedData, setselectedData] = useState();
  const [editData, setEditData] = useState(null);
  const [totalpages, setTotalPages] = useState();
  const [currentPage, setCurrentPages] = useState(1);
  const [totalCount, setTotalcount] = useState();
  const [search, setSearch] = useState();
  const [tabSearch, setTabSearch] = useState();
  const [status, setStatus] = useState(categoryId ? categoryId : "");
  const [paystatus, setPayStatus] = useState();
  const [sortstatus, setSortStatus] = useState();
  const rowsperpage = 10;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedOrderid, setSelectedOrderId] = useState("");
  const [getOrder, setgetOrder] = useState(false);
  const [searchparams] = useSearchParams();
  const filter = searchparams.get("filtertype");
  const startDate = searchparams.get("startDate");
  const endDate = searchparams.get("endDate");
  const [download, setDownload] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleCloseFilter = () => setAnchorEl(null);

  const handleConsultationData = async (
    search,
    currentPage,
    rowsperpage,
    tabSearch,
    filter,
    startDate,
    endDate,
    status,
    paystatus,
    sortstatus,
    download
  ) => {
    const params = {
      search,
      page: currentPage,
      // ...(!download ? { limit: rowsperpage } : { limit: totalpages * rowsperpage }),
      // limit: rowsperpage,
      // sortBy: "createdAt",
      // sortOrder: "desc",
      ...(download ? { page: 1 } : { page: currentPage }),
      ...(download
        ? { limit: totalpages * rowsperpage }
        : { limit: rowsperpage }
      ),
      ...(filter && { sortBy: "consultation_date", startDate: startDate, endDate: endDate }),
      ...(status && status !== "None" && { status }),
      ...(paystatus && paystatus !== "None" && { payment_status: paystatus }),
      ...(sortstatus && sortstatus !== "None" && { sortBy: sortstatus }),
      ...(tabSearch && { consultation_type: tabSearch }),
      download
    };

    try {
      setLoading(true)
      const response = await instance.get("/Consultation/getConsultations", { params });
      if (download) {
        DownloadExportData(response.data);
        setDownload(false);
      } else {
        const formatteddata = response?.data?.data?.map((consultation, index) => ({
          sno: index + 1,
          ConsultationID: consultation?.consultation_id || "---",
          Customer: consultation?.name
            ? consultation?.name
            : consultation?.Customer?.name,
          Bookingdate: consultation?.consultation_date
            ? new Date(consultation?.consultation_date).toLocaleDateString()
            : "----",
          consultationtype: consultation?.consultation_type
            ? consultation?.consultation_type
            : "----",
          Assignedperson: consultation?.Admin?.name
            ? consultation?.Admin?.name
            : "----",
          suborderstatus: consultation?.status ? consultation?.status : "----",
          order_id: consultation?.Order?.order_id,
          paymentstatus: consultation?.payment_status
            ? consultation?.payment_status
            : "----",
          consultantData: consultation,
        })
        );
        setConsultationData(formatteddata);
        setTotalPages(response?.data?.totalPages);
        setCurrentPages(response?.data?.currentPage);
        setTotalcount(response?.data?.total);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false)
    }
  };
  useEffect(() => {
    handleConsultationData(search, currentPage, rowsperpage, tabSearch, filter, startDate, endDate, status, paystatus, sortstatus, download);
    setLoading(true);
  }, [search, currentPage, tabSearch, download]);

  const handleViewClick = (employee) => {
    setselectedData(employee);
    setopenviewDialog(true);
    setEditData(false);
  };

  const handleEditClick = (employee) => {
    setEditData(true);
    setselectedData(employee);
    setopenviewDialog(true);
  };
  const handlevieworderClick = (employee) => {
    setSelectedOrderId(employee?.order_id);
    setOpenDialog(true);
  };

  const handleOrderClick = (order) => {
    navigate(`/admin/orderinfo/${order?.consultantData?.order_id}`);
  };

  const handleaccept = async (data) => {
    try {
      const response = await instance.patch('/Consultation/assignConsultation', {
        consultation_id: data?.consultantData?._id
      });
      if (response.status === 200) {
        toast.success(response.data.message);
        handleConsultationData();
      } else {
        // console.log(response.data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handleConsultApplyFilter = () => {
    
    handleConsultationData(
      search,
      currentPage,
      rowsperpage,
      tabSearch,
      filter,
      startDate,
      endDate,
      status,
      paystatus,
      sortstatus,
      false
    );
    setAnchorEl(null);
  };

  const handleresetCloseFilter = () => {
    setStatus("");
    setPayStatus("");
    setSortStatus("");
    setTabSearch("");
    setSearch("");

    handleConsultationData(
      "",
      1,
      rowsperpage,
      "",
      "",
      "",
      "",
      "",
      "",
      "",
      false
    );

    handleCloseFilter()
  };


  return (
    <>
      <Topbar />
      <section className="admin-catalogue">
        <PageHeader
          button={"consultation"}
          title={title}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          setSearch={setSearch}
          showButton={false}
          files={true}
          Download={() => setDownload(true)}
        />
        <SubHeader
          menu={true}
          filter={true}
          isVisible={true}
          isConsultationPage={true}
          setSortStatus={setSortStatus}
          sortstatus={sortstatus}
          SortOptions={SortOptions}
          setTabSearch={setTabSearch}
          statusOptions={statusOptions}
          paymentOptions={paymentOptions}
          tabsData={tabsData}
          sortOptions={sortOptions}
          setStatus={setStatus}
          status={status}
          setPayStatus={setPayStatus}
          paystatus={paystatus}
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          open={open}
          handleClick={handleClick}
          handleCloseFilter={handleCloseFilter}
          handleConsultApplyFilter={handleConsultApplyFilter}
          handleClearFilter={handleresetCloseFilter}
        />
        {loading ? (
          <div className='loader-section'>
            <CircularProgress />
          </div>
        ) : (<CommonTable
          columns={columns}
          rows={consultationData}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          openviewDialog={openviewDialog}
          setopenviewDialog={setopenviewDialog}
          edit={edit}
          setEdit={setEdit}
          openConsultationDialog={openConsultationDialog}
          setOpenConsultationDialog={setOpenConsultationDialog}
          handlevieworderClick={handlevieworderClick}
          banner={true}
          menu={true}
          handleViewClick={handleViewClick}
          handleEditClick={handleEditClick}
          totalpages={totalpages}
          rowsperpage={rowsperpage}
          totalCount={totalCount}
          currentPage={currentPage}
          setCurrentPages={setCurrentPages}
          handleOrderClick={handleOrderClick}
          handleaccept={handleaccept}
        />
        )}
        {/* <ViewConsultationInfo
          download={"consultation"}
          editData={editData}
          handleConsultationData={handleConsultationData}
          customerdata={selectedData?.consultantData}
          edit={edit}
          setEdit={setEdit}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          openviewDialog={openviewDialog}
          setopenviewDialog={setopenviewDialog}
        /> */}
        {/* <CancelConsultation 
        openDialog={openDialog}
        openviewDialog={openviewDialog}
        setopenviewDialog={setopenviewDialog}
        setOpenDialog={setOpenDialog}
        openviewCancelDialog={openviewCancelDialog}
        setopenviewCancelDialog={setopenviewCancelDialog}
        /> */}
        <ViewConsultationInfo
          download={'consultation'}
          editData={editData}
          handleConsultationData={handleConsultationData}
          customerdata={selectedData?.consultantData}
          edit={edit}
          setEdit={setEdit}
          openDialog={openDialog}
          setOpenDialog={setOpenDialog}
          openviewDialog={openviewDialog}
          setopenviewDialog={setopenviewDialog}

        />
        {/* <Vieworder
          openviewDialog={openDialog}
          setopenviewDialog={setOpenDialog}
          selectedOrder={selectedOrder}
          // setgetOrder={setgetOrder}
          mode="orders"
        /> */}
      </section>

    </>
  );
};

export default Consultation;
